import type {
  CompletionEvidence,
  CompletionEvidenceStatus,
  CompletionResolutionStatus,
} from '../types';

const recoverableFailureStatuses: CompletionEvidenceStatus[] = [
  'extraction_failed',
  'ocr_failed',
  'not_found',
];

export const completionEvidenceLabels: Record<CompletionEvidenceStatus, string> = {
  verified: 'מאומת',
  calculated: 'מחושב',
  candidate: 'נמצא ערך — נדרש אישור',
  not_found: 'לא נמצא',
  not_disclosed: 'לא פורסם',
  not_applicable: 'לא חל',
  external_required: 'נדרש מקור חיצוני',
  extraction_failed: 'כשל חילוץ',
  ocr_failed: 'כשל OCR',
  contradictory: 'נמצאה סתירה',
  superseded: 'הוחלף',
};

export const completionResolutionLabels: Record<CompletionResolutionStatus, string> = {
  open: 'פתוח לטיפול',
  auto_retry: 'חילוץ ממוקד פועל',
  manual_review: 'ממתין לאישור אנליסט',
  waiting_external: 'ממתין למקור חיצוני',
  resolved: 'הושלם',
  accepted_limitation: 'נסגר עם מגבלה',
};

export const isCompletionEvidenceApprovable = (evidence: CompletionEvidence): boolean => (
  evidence.approvable ?? Boolean(
    evidence.value
    && evidence.quote
    && evidence.source_document_id != null
    && (evidence.page != null || evidence.section_title),
  )
);

export const completionEvidenceDisplayLabel = (
  status: CompletionEvidenceStatus,
  hasApprovableEvidence: boolean,
): string => (
  hasApprovableEvidence && recoverableFailureStatuses.includes(status)
    ? 'ראיה קיימת — נדרש אישור'
    : completionEvidenceLabels[status]
);

export const completionEvidenceReviewCopy = (
  status: CompletionEvidenceStatus,
  hasApprovableEvidence: boolean,
): string | undefined => {
  if (!hasApprovableEvidence || status === 'verified' || status === 'calculated') return undefined;
  if (recoverableFailureStatuses.includes(status)) {
    return 'הניסיון האוטומטי לא אימת את הערך, אך הערך והציטוט נשמרו. בדוק אותם ואשר כדי לפתור את הפער.';
  }
  return 'בדוק שהערך והציטוט מתאימים, ואז אשר כדי לפתור את הפער ולעדכן את מדדי המוכנות.';
};

export const targetedCompletionOutcomeCopy = (status?: string): string => {
  if (status === 'filled') return 'נמצאה ראיה מאומתת והסטטוס עודכן אוטומטית';
  if (status === 'needs_review') return 'נמצא ערך חדש. בדוק את המקור ולחץ „אשר ועדכן את הסטטוס”';
  if (status === 'missing') return 'החילוץ הסתיים, אך הערך עדיין לא נמצא בדוח';
  return 'החילוץ הממוקד הסתיים. בדוק את מצב הסעיף והראיה האחרונה';
};
